import { gql } from '@apollo/client'

export const TERRITORY_CATEGORIES = gql`
  query territoryCategories($languages: [String!]!) {
    allTopicGroups(languages: $languages) {
      topicGroupId
      title
      language
      topics {
        createdAt
        topicId
      }
    }
  }
`
